export const crops = [
  'Corn',
  'Cotton',
  'Sorghum',
  'Soybeans',
  'Sunflower',
  'Other (please specify)'
];

export const weedControlMethodOptions = [
  'Thermal weed control (e.g., flame or steam)',
  'Herbicides (non-organic)',
  'Organic herbicides',
  'Mechanical cultivation',
  'Hand weeding and hoeing',
  'Mulching/substrate cultures (e.g., peat soil mixtures, sawdust, and coconut fiber)',
  'No weed control',
  'Other (please specify)'
];

export const replacementOptions = [
  'N/A: The propane-fueled flame weed control system is not replacing or reducing the use of another weed control method',
  'Thermal weed control (i.e., flame or steam)',
  'Herbicides (non-organic)',
  'Organic herbicides',
  'Mechanical cultivation',
  'Hand weeding / hoeing',
  'Mulching/substrate cultures (e.g., peat soil mixtures, sawdust, and coconut fiber)',
  'Other (please specify)'
];

export const consideredPowerSourcesChoices = {
  propane: 'Different propane-fueled heating system',
  ['Fuel oil heating system']: 'Fuel oil heating system',
  ['Grid-supplied electricity']: 'Grid-supplied electricity',
  ['Natural-gas-fueled heating system']: 'Natural-gas-fueled heating system',
  ['Solar heating system']: 'Solar heating system',
  other: 'Other (please specify)'
};
